import React from 'react';

import foldSvg from '@assets/img/icons/fold.svg';

export const TableFoldButton: React.FC<{
  folded: boolean;
  onValueChange: (folded: boolean) => void;
}> = ({ folded, onValueChange }) => {
  return (
    <button aria-label="fold table" onClick={() => onValueChange(!folded)}>
      <img
        src={foldSvg}
        width={12}
        height={12}
        style={{ transform: folded ? 'rotate(90deg)' : undefined }}
      />
    </button>
  );
};
